// GetDrawerNavigation returns the core navigation for a Drawer Navigation.
//
// A Drawer Navigation can be found on Mobile Web currently.
export const NavigationService_GetDrawerNavigationBulkLazy = () =>
  import("./service.grpc").then(
    (m) => m.NavigationService_GetDrawerNavigationBulk
  );
NavigationService_GetDrawerNavigationBulkLazy.method =
  "aysa_api.services.navigation.v1.NavigationService/GetDrawerNavigationBulk" as const;

// GetDrawerRecommendations returns user tailored inspirational content,
// such as Stories, Brands and more.
//
// The endpoint is supposed to be used on the Drawer Navigation found on Mobile Web,
export const NavigationService_GetDrawerRecommendationsLazy = () =>
  import("./service.grpc").then(
    (m) => m.NavigationService_GetDrawerRecommendations
  );
NavigationService_GetDrawerRecommendationsLazy.method =
  "aysa_api.services.navigation.v1.NavigationService/GetDrawerRecommendations" as const;

// GetHeader returns all information required to display the Header on desktop.
export const NavigationService_GetHeaderBulkLazy = () =>
  import("./service.grpc").then((m) => m.NavigationService_GetHeaderBulk);
NavigationService_GetHeaderBulkLazy.method =
  "aysa_api.services.navigation.v1.NavigationService/GetHeaderBulk" as const;

// GetResolvedTargetGroup returns the gender it would resolve the `GetHeaderBulk` request to based on the identifier and the session_target_group.
export const NavigationService_GetResolvedTargetGroupLazy = () =>
  import("./service.grpc").then(
    (m) => m.NavigationService_GetResolvedTargetGroup
  );
NavigationService_GetResolvedTargetGroupLazy.method =
  "aysa_api.services.navigation.v1.NavigationService/GetResolvedTargetGroup" as const;

// returns affected categories by the campaign/coupon reduction to show sale hints on the frontend
export const NavigationService_GetHeaderHintsLazy = () =>
  import("./service.grpc").then((m) => m.NavigationService_GetHeaderHints);
NavigationService_GetHeaderHintsLazy.method =
  "aysa_api.services.navigation.v1.NavigationService/GetHeaderHints" as const;

// returns a oneof of possible desktop top banners
export const NavigationService_GetDesktopTopBannerLazy = () =>
  import("./service.grpc").then((m) => m.NavigationService_GetDesktopTopBanner);
NavigationService_GetDesktopTopBannerLazy.method =
  "aysa_api.services.navigation.v1.NavigationService/GetDesktopTopBanner" as const;

// returns the USPs for the header
export const NavigationService_GetHeaderUspsLazy = () =>
  import("./service.grpc").then((m) => m.NavigationService_GetHeaderUsps);
NavigationService_GetHeaderUspsLazy.method =
  "aysa_api.services.navigation.v1.NavigationService/GetHeaderUsps" as const;
